// 工具类函数存放
import wx from 'weixin-js-sdk'
const payment = {
  props: {},
  data() {
    return {
      showResult: false,
      payConfig: {},
    }
  },
  created() {
    // this.$store.commit('publicData/setCoupons', {})
    this.studyQuery = this.$route.query.studyQuery
    this.isMemberVip()
  },

  methods: {
    //是否是VIP
    async isMemberVip() {
      let res = await this.api.vip.isMemberVip()
      if (res && res.code == 200) {
        this.memberVip = res.data.memberVip == 0 ? false : true;
      }
    },
    //选择支付方式
    selectData(payWays) {
      this.payWays = payWays;
    },
    //对公支付
    async corporatePay() {
      this.makeOrderParams();
      let res = await this.api.wxPay.placeOrder(this.params)
      if (res && res.code == 200) {
        this.$router.push({
          path: "/order-info",
          query: {
            orderNo: res.data.orderNo,
          }
        })
      }
    },
    //生成订单
    async weChatPay() {
      //是否参与团购0:普通订单，1:团购购买订单 (私教坊 isTuan为1)
      let isTuan = 0;
      if(this.$route.query.isGoodsStatus){
        if(this.$route.query.isGoodsStatus == 'true' && this.isGoodsGroup == 1 || this.goodsType == 2){
          isTuan = 1;
        }
      } else {
        isTuan = this.isGoodsGroup;
      }
      // 开发环境跳过支付
      if (process.env.VUE_APP_SKIP_PAYMENT == 'true') {
        console.log({
          actType: this.usageCouponInfo.usageType, //活动类型:(0：不参与活动 1：训练营抵扣券 2：私教坊抵扣券 3：8折购课 4：满减券 5:团购)
          adminId: this.adminId ? this.adminId : '', //	推广员id
          couponId: this.curCoupon.id ? this.curCoupon.id : null,  //无优惠不传
          goodType: this.goodsType * 1, //0:轻课 1:训练营 2:私教坊  3:专栏  4:会员VIP
          goodsId: this.dataInfo.id, //	商品ID
          isTuan: isTuan,
          orderNo: '',
          packId: this.curPackage.id ? this.curPackage.id : 0, //团购套餐ID
          packNum: this.buyNum, //团购购买数量
          payWays: this.payWays2, //付款（0:微信，1:支付宝，2:好友赠送，3:余额支付,4:对公支付,5:零元购，6：抵扣券）
          signMobile: this.form && this.form.mobile ? this.form.mobile : '',
          signName: this.form && this.form.userName ? this.form.userName : '',
        })
        this.jumpToQrCode(1)
      }
      if (!this.showResult) {
        this.makeOrderParams()
        this.showResult = true;
        let order = 'placeOrder'
        if (this.origin == 'miniprogram') {
          order = 'minOrder'
          this.params.openId = this.minOpenid
          // alert(this.params.openId)
        }
        let res = await this.api.wxPay[order](this.params)
        if (res && res.code == 200) {
          this.payConfig = res.data;
          setTimeout(() => {
            this.showResult = false;
          }, 1000)

          this.onBridgeReady() //唤起支付
        } else {
          this.showResult = false;
        }
      }
    },
    //下单参数
    makeOrderParams() {
      //是否参与团购0:普通订单，1:团购购买订单 (私教坊 isTuan为1)
      let isTuan = 0;
      if(this.$route.query.isGoodsStatus){
        if(this.$route.query.isGoodsStatus == 'true' && this.isGoodsGroup == 1 || this.goodsType == 2){
          isTuan = 1;
        }
      } else {
        isTuan = this.isGoodsGroup;
      }
      this.params = {
        actType: this.usageCouponInfo.usageType, //活动类型:(0：不参与活动 1：训练营抵扣券 2：私教坊抵扣券 3：8折购课 4：满减券 5:团购)
        adminId: this.adminId ? this.adminId : '', //	推广员id
        couponId: this.curCoupon.id,  //无优惠不传
        goodType: this.goodsType, //0:轻课 1:训练营 2:私教坊  3:专栏  4:会员VIP
        goodsId: this.dataInfo.id, //	商品ID
        isTuan: isTuan,
        orderNo: '',
        packId: this.curPackage.id ? this.curPackage.id : 0, //团购套餐ID
        packNum: this.buyNum, //团购购买数量
        payWays: this.payWays, //付款（0:微信，1:支付宝，2:好友赠送，3:余额支付,4:对公支付,5:零元购，6：抵扣券）
        signMobile: this.form && this.form.mobile ? this.form.mobile : '',
        signName: this.form && this.form.userName ? this.form.userName : '',
      }
    },
    // 唤起微信支付
    onBridgeReady() {
      if (this.origin != 'miniprogram') {
        this.openMessageBox()
      }
      let self = this
      let data = {
        appId: this.payConfig.wxdata.appId, //公众号名称，由商户传入
        timeStamp: this.payConfig.wxdata.timeStamp, //时间戳，自1970年以来的秒数
        nonceStr: this.payConfig.wxdata.nonceStr, //随机串
        package: this.payConfig.wxdata.package, //预支付返回数据
        signType: 'MD5', //微信签名方式：
        paySign: this.payConfig.wxdata.paySign, //微信签名
      }
      //   "actType": 0,
      // "isSueecess": 0,
      // "orderNo": "20220628002087148013",
      // "payways": 0,
      // "wxdata": {}
      // 小程序传参数
      // alert(JSON.stringify(data))
      // let auth = this.getCookie('Authorization')
      // console.log(auth)
      // alert(auth)
      if (this.origin == 'miniprogram') {
        let miniData = {
          timeStamp: this.payConfig.wxdata.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: this.payConfig.wxdata.nonceStr, //随机串
          package: this.payConfig.wxdata.package.replace('prepay_id=', ''), //预支付返回数据
          signType: 'MD5', //微信签名方式
          paySign: this.payConfig.wxdata.paySign,
        }
        let params = JSON.stringify(miniData)
        // 唤起小程序支付
        wx.miniProgram.navigateTo({
          url: '/pages/payment/payment?params='+params+'&order='+this.payConfig.orderNo
        })
        return
      }
      WeixinJSBridge.invoke('getBrandWCPayRequest', data, function (res) {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        } else {
          self.showResult = false;
          self.$router.go(0)
        }
      })
    },
    //支付确认弹回调函数
    openMessageBox() {
      this.$messageBox({
        title: '您是否支付成功？',
        cancelBtnText: '否',
        confirmBtnText: '是',
        show: true,
        cancelCallback: () => {
          this.showResult = false;
        },
        confirmCallback: () => {
          this.showResult = false;
          this.paySuccess()
        }
      })
    },

    async paySuccess() {
      let res = await this.api.wxPay.paySuccess(this.payConfig.orderNo)
      if (res && res.code == 200) {
        // 显示支付成功 isSuccess:1已付款  0 未付款
        if (res.data.isSuccess == 1) {
          this.paySuccessCallback(1, res.data)
        } else {
          this.jumpToQrCode(2)
        }
      }
    },
    confirmUserInfo() {
      this.jumpToQrCode(1)
    },
    //支付跳转二维码页面
    paySuccessCallback(type, data) {
      // 1：训练营, 2：私教坊  ->跳转信息收集页
      if (this.dataInfo.type == 1 || this.dataInfo.type == 2 && data.isCollect) {
        this.showInfo = true
      } else {
        this.jumpToQrCode(type)
      }

    },
    jumpToQrCode(type) {
      this.$router.push({
        path: '/qrCore',
        query: {
          id: this.payConfig.orderNo,
          type: type,
          jumpType: this.jumpType,
          goodsId: this.dataInfo.id, //	商品ID
          studyQuery: this.studyQuery,
        },
      })
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
      }
      return "";
    }
  }
};
export default payment
